import { render } from "./ContactsList.vue?vue&type=template&id=bf4320f6"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"

import "./ContactsList.vue?vue&type=style&index=0&id=bf4320f6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__